import React, { PropsWithChildren } from 'react'
import { useParams } from 'react-router-dom'
import { PageLink as Link } from 'src/app/AppAuth/PageLink'
import { generateAuditPermalink } from 'src/components/PageLayout/Permalink'
import { DirectRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { GridRow } from 'src/components/Reusable/Grid'

type Props = PropsWithChildren<{
  isSelected?: boolean
  isClosed?: boolean
  auditId: string
}>

export function AuditRow(props: Props): JSX.Element {
  const id = `audit-index-item-${props.auditId}`
  const params = useParams()
  const pageContext = params.pageContext as string

  if (props.isClosed) {
    return (
      <GridRow selected={props.isSelected} id={id}>
        {props.children}
      </GridRow>
    )
  }

  return (
    <GridRow
      selected={props.isSelected}
      id={id}
      as={Link}
      to={generateAuditPermalink({
        pageContext,
        isInternalLink: true,
        overrideAuditId: props.auditId,
        destination: DirectRoutes.GRC_DASHBOARDS,
      })}
    >
      {props.children}
    </GridRow>
  )
}
